export default "__VITE_ASSET__BehG5gCC__"